import {
	random,
	findIndex,
	max
} from 'lodash';

import {isEqual} from 'lodash';

import {
	store
} from '../stores/mainStore';

import {response0} from './tutorial/response0';
import {response1} from './tutorial/response1';
import {response2} from './tutorial/response2';
import {response3} from './tutorial/response3';
import {response4} from './tutorial/response4';
import {response5} from './tutorial/response5';
import {response6} from './tutorial/response6';
import {response7} from './tutorial/response7';
import {response8} from './tutorial/response8';
import {response9} from './tutorial/response9';
import {response10} from './tutorial/response10';
import {response11} from './tutorial/response11';
import {response12} from './tutorial/response12';
// import {response13} from './tutorial/response13';
import {response14} from './tutorial/response14';
import {response15} from './tutorial/response15';
import {response15_1} from './tutorial/response15.1';
// import {response16} from './tutorial/response16';

window.isEqual = isEqual;

export class TutorialServer {
	constructor(index = 0) {
		this.callIndex = index;
		this.mockResponses = [
			response0, //intro royal
			response1, //intro royal
			response1, //intro royal
			response2,
			response3,
			response4,
			response5,
			response6,
			response7,
			response8,
			response9,
			response10,
			response11,
			response12,
			response12,
			response14,
			response15,
			response15_1,
			response15_1,
			response15_1,
			response15_1
		];

		this.responses = JSON.parse(JSON.stringify(this.mockResponses));

		window.test = this.test;
		window.testSet = this.testSet;
		this.madeRoyal = false; //this isn't needed anymore. the addition of the response takes care of the success call.
	}

	CallRoute(route, payload) {
		console.log('MockData:', route, this.callIndex, this.responses[this.callIndex]);
		var r = this.responses[this.callIndex];
		this.callIndex++;
		return this.Response(r);
		// var response = this.responses[this.callIndex];
		// if(!response){
		// 	//generate a response
		// 	//{MatchId: 178, Selection: [], GiveUp: false}
		// 	this.cannedFailure.Payload.Match.Wager.Amount.Quantity = integration.tutorialWager;
		// 	this.cannedFailure.Payload.Match.Wager.Resolution.Amount.Quantity = integration.tutorialPayout;
		// 	if(payload.GiveUp){
		// 		response = {"Payload":{"UserMatchComplete":true},"ErrorCode":0,"ErrorMessage":""};
		// 		this.responses.push(response);
		// 		this.responses.push(this.cannedFailure);
		// 	} else {
		// 		response = this.generateRoll(payload.Selection);
		// 		this.hands[2].rolls.push(response.Payload.MatchRoll);
		// 		this.responses.push(response);
		// 		//all matches are best matches
		// 		if(response.Payload.MatchRoll.BestPossibleHand){
		// 			this.madeRoyal = true;
		// 			this.responses.push({"Payload":{"UserMatchComplete":true},"ErrorCode":0,"ErrorMessage":""});
		// 			this.responses.push(this.createSuccess(response.Payload.MatchRoll.BestHand));
		// 		}
		// 	}
		// }
		// console.log(`route: ${route} i: ${this.callIndex}`, response);
		// this.callIndex++;
		// return this.Response(response);
	}

	generateRoll(held){
		var dice = store.activeMatch.currentHand.dice;
		var next = dice.map(d => d.held ? d.showing : random(0, 5));//[0,0,0,0,0,0,0,0,0]//[0,3,1,2,0,4,4,3,0];
		var bestHand = this.evaluate(next);
		var roll = {
			"Payload": {
				"MatchRoll": {
					"RollNum": this.hands[2].rolls.length + 1,
					"DiceRoll": next,
					"DiceRollStrings": ["7s", "6c", "Th", "Tc", "9d", "6h", "Kc", "4h", "7d"], //not acurate
					"Selection": held,
					"FreeRoll": false,
					"Completed": false,
					"BestHand": bestHand,
					"BestPossibleHand": bestHand.length > 0
				},
				"UserMatchComplete": !!bestHand
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		}
		return roll;
	}

	test = () => {

		const arr1= [0,1,2,3,4,5];

		const all = [arr1,arr1,arr1,arr1,arr1,arr1,arr1,arr1,arr1];

		const output = all.reduce((acc, cu) => {
			let ret = [];
			acc.forEach(obj => {
				cu.forEach(obj_1 => {
					ret.push(obj + '-' + obj_1)
				});
			});
			return ret;
		});

		console.log(output);


		var count = 0;

		var run = (start) => {
			output.slice(start, start+1000).forEach(o => {
				var testDice = o.split('-');
				//console.log(testDice.map(d => d.showing));
				var result = this.evaluate(testDice.map(t => { return {showing: t}; }));
				if(result.length){
					//console.log(result);
					count++;
				}
			})
			setTimeout(() => { run(start+1001); console.log(count);}, 1);
		}

		run(0);

		// 	var iToInc = findIndex(testDice, d => d.showing < 5);
		// 	testDice[iToInc].showing++;
		// 	console.log(testDice.map(d => d.showing));
		// 	var result = this.evaluate(testDice);
		// 	if(result.length){
		// 		console.log(result);
		// 		count++;
		// 	}
		// }
	}

	testSet = (set) => {
		return this.evaluate(set);
	}

	evaluate(dice){

		var wilds = [dice[1] === 3, dice[5] === 4];
		var wildCount = wilds.filter(w => w).length;

		var hands = [
			[4, null, null, 1, null, 5, 3, null, 1],//clubs
			[null, null, 5, null, 0, null, 0, 0, 3],//spades
			[2, null, 1, 2, null, null, 4, 3, null],//diamonds
			[null, 0, 2, 0, 5, null, null, null, 0] // hearts
		];



		var hits = [0,0,0,0];
		var diceIndexesForHands = [[],[],[],[]];
		dice.forEach((d, i) => {
			hands.forEach((h, j) => {
				if(h[i] === d){
					hits[j]++;
					diceIndexesForHands[j].push(i);
				}
			})
		});

		var count = max(hits);
		if(count + wildCount < 5){
			return [];
		}

		var order = [
			[0,6,5,8,3],//clubs
			[4,2,6,7,8],//spades
			[7,3,2,0,6],//diamonds
			[1,8,3,4,2] // hearts
		]

		var getWild = () => {
			if(wilds[0]){
				wilds[0] = false;
				return 1;
			}
			if(wilds[1]){
				wilds[1] = false;
				return 5;
			}
		}

		var suitIndex = findIndex(hits, h => h === count);
		var suitDice = diceIndexesForHands[suitIndex];
		return order[suitIndex].map(o => {
			return suitDice.indexOf(o) > -1 ? o : getWild();
		});
	}

	hands = [{
		rolls: [
			{
				"RollNum": 1,
				"DiceRoll": [1, 2, 1, 4, 5, 3, 5, 0, 3],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [],
				"BestPossibleHand": false
			},
			{
				"RollNum": 2,
				"DiceRoll": [0, 3, 2, 5, 5, 3, 2, 0, 2],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [4, 7],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [],
				"BestPossibleHand": false
			},
			{
				"RollNum": 3,
				"DiceRoll": [4, 3, 1, 2, 5, 2, 2, 0, 4],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [1, 4, 7],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [0, 1, 4, 7],
				"BestPossibleHand": false
			}
		]
	},{
		rolls: [
			{
				"RollNum": 1,
				"DiceRoll": [1, 0, 0, 1, 3, 1, 4, 0, 1],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [],
				"BestPossibleHand": false
			},
			{
				"RollNum": 2,
				"DiceRoll": [1, 0, 0, 2, 4, 4, 5, 1, 3],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [0,1,2],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [],
				"BestPossibleHand": false
			},
			{
				"RollNum": 3,
				"DiceRoll": [1, 0, 0, 5, 4, 4, 5, 1, 4],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [0,1,2,5],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [],
				"BestPossibleHand": false
			},
			{
				"RollNum": 4,
				"DiceRoll": [1, 0, 0, 0, 4, 4, 1, 2, 1],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [0,1,2,5],
				"FreeRoll": true,
				"Completed": false,
				"BestHand": [1,5,3,2,0],
				"BestPossibleHand": false
			}
		]
	},{
		rolls: [
			{
				"RollNum": 1,
				"DiceRoll": [0, 3, 0, 3, 4, 2, 4, 3, 5],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [],
				"FreeRoll": false,
				"Completed": false,
				"BestHand": [],
				"BestPossibleHand": false
			}
		]
	}];

	rounds = [
		{
			"RoundNum": 1,
			"Rolls": 3,
			"Winner": 0,
			"TargetHand": 3,
			"State": 2
		},
		{
			"RoundNum": 2,
			"Rolls": 3,
			"Winner": 0,
			"TargetHand": 6,
			"State": 2
		},
		{
			"RoundNum": 3,
			"Rolls": 3,
			"Winner": 0,
			"TargetHand": 12,
			"State": 2
		}
	]

	opponentMatchRounds = [
		{
			"RoundNum": 1,
			"Score": 2,
			"FinalScore": 2,
			"FreeRollsUsed": 0,
			"State": 3,
			"BestHand": [2, 3, 8, 1],
			"BestPossibleHand": false,
			"FinalDiceRoll": null,
			"Rolls": [{
				"RollNum": 1,
				"DiceRoll": [0, 5, 2, 1, 3, 1, 4, 0, 4],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [],
				"FreeRoll": false,
				"Completed": true,
				"BestHand": [2, 3, 8, 1],
				"BestPossibleHand": false
			}]
		},{
			"RoundNum": 2,
			"Score": 5,
			"FinalScore": 5,
			"FreeRollsUsed": 0,
			"State": 3,
			"BestHand": [3, 2, 0, 4, 1],
			"BestPossibleHand": false,
			"FinalDiceRoll": null,
			"Rolls": [{
				"RollNum": 1,
				"DiceRoll": [2, 2, 1, 2, 2, 0, 0, 0, 0],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [],
				"FreeRoll": false,
				"Completed": true,
				"BestHand": [3, 2, 0, 4, 1],
				"BestPossibleHand": false
			}]
		},{
			"RoundNum": 3,
			"Score": 0,
			"FinalScore": 0,
			"FreeRollsUsed": 0,
			"State": 3,
			"BestHand": [],
			"BestPossibleHand": false,
			"FinalDiceRoll": null,
			"Rolls": [{
				"RollNum": 1,
				"DiceRoll": [0, 0, 2, 1, 3, 1, 4, 0, 4],
				"DiceRollStrings": ["Ac", "6c", "Qd", "9s", "Jh", "6h", "5s", "Js", "Ts"],
				"Selection": [],
				"FreeRoll": false,
				"Completed": true,
				"BestHand": [],
				"BestPossibleHand": false
			}]
		}
	];

	responses = [
		{
			"Payload": {
				"MatchId": 1
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"Match": {
					"Id": 1,
					"Version": 1,
					"Winner": 0,
					"State": 2,
					"PlayerCount": 2,
					"RoundCount": 3,
					"CreatedTimestamp": 1551913551,
					"UpdatedTimestamp": 1551913551,
					"UserMatchState": 2,
					"UserCurrentRound": 1,
					"UserFreeRolls": 2,
					"UserFreeRollsUsed": 0,
					"UserTotalScore": 0,
					"OpponentUserId": 2,
					"OpponentUsername": "Practice Player",
					"OpponentTotalScore": 0,
					"BetAmounts": {
						"Buyin": {
							"Amount": -10000,
							"Type": "USD"
						},
						"Payout": null,
						"Resolution": null,
						"Refund": null
					},
					"Rounds": this.rounds.slice(0,1),
					"UserMatchRounds": [{
						"RoundNum": 1,
						"Score": 0,
						"FinalScore": 0,
						"FreeRollsUsed": 0,
						"State": 2,
						"BestHand": [],
						"BestPossibleHand": false,
						"FinalDiceRoll": null,
						"Rolls": []
					}],
					"OpponentMatchRounds": []
				}
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[0].rolls[0],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[0].rolls[1],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[0].rolls[2],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"Match": {
					"Id": 33,
					"Version": 1,
					"Winner": 0,
					"State": 2,
					"PlayerCount": 2,
					"RoundCount": 3,
					"CreatedTimestamp": 1552001440,
					"UpdatedTimestamp": 1552001440,
					"UserMatchState": 2,
					"UserCurrentRound": 2,
					"UserFreeRolls": 2,
					"UserFreeRollsUsed": 0,
					"UserTotalScore": 0,
					"OpponentUserId": 2,
					"OpponentUsername": "Practice Player",
					"OpponentTotalScore": 0,
					"BetAmounts": {
						"Buyin": {
							"Amount": -10000,
							"Type": "USD"
						},
						"Payout": null,
						"Resolution": null,
						"Refund": null
					},
					"Rounds": this.rounds.slice(0,2),
					"UserMatchRounds": [{
						"RoundNum": 1,
						"Score": 2,
						"FinalScore": 4,
						"FreeRollsUsed": 0,
						"State": 3,
						"BestHand": [1, 5, 6, 2],
						"BestPossibleHand": false,
						"FinalDiceRoll": null,
						"Rolls": this.hands[0].rolls
					}, {
						"RoundNum": 2,
						"Score": 0,
						"FinalScore": 0,
						"FreeRollsUsed": 0,
						"State": 2,
						"BestHand": [],
						"BestPossibleHand": false,
						"FinalDiceRoll": null,
						"Rolls": []
					}],
					"OpponentMatchRounds": this.opponentMatchRounds.slice(0,1)
				}
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[1].rolls[0],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[1].rolls[1],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[1].rolls[2],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[1].rolls[3],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"Match": {
					"Id": 33,
					"Version": 1,
					"Winner": 0,
					"State": 2,
					"PlayerCount": 2,
					"RoundCount": 3,
					"CreatedTimestamp": 1552001440,
					"UpdatedTimestamp": 1552001440,
					"UserMatchState": 2,
					"UserCurrentRound": 2,
					"UserFreeRolls": 2,
					"UserFreeRollsUsed": 0,
					"UserTotalScore": 0,
					"OpponentUserId": 2,
					"OpponentUsername": "Practice Player",
					"OpponentTotalScore": 0,
					"BetAmounts": {
						"Buyin": {
							"Amount": -10000,
							"Type": "USD"
						},
						"Payout": null,
						"Resolution": null,
						"Refund": null
					},
					"Rounds": this.rounds.slice(0,3),
					"UserMatchRounds": [{
						"RoundNum": 1,
						"Score": 2,
						"FinalScore": 4,
						"FreeRollsUsed": 0,
						"State": 3,
						"BestHand": [1, 5, 6, 2],
						"BestPossibleHand": false,
						"FinalDiceRoll": null,
						"Rolls": this.hands[0].rolls
					}, {
						"RoundNum": 2,
						"Score": 5,
						"FinalScore": 10,
						"FreeRollsUsed": 0,
						"State": 2,
						"BestHand": [1,5,3,2,0],
						"BestPossibleHand": false,
						"FinalDiceRoll": null,
						"Rolls": this.hands[1].rolls
					}, {
						"RoundNum": 3,
						"Score": 0,
						"FinalScore": 0,
						"FreeRollsUsed": 0,
						"State": 2,
						"BestHand": [],
						"BestPossibleHand": false,
						"FinalDiceRoll": null,
						"Rolls": []
					}],
					"OpponentMatchRounds": this.opponentMatchRounds.slice(0,2)
				}
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		},
		{
			"Payload": {
				"MatchRoll": this.hands[2].rolls[0],
				"UserMatchComplete": false
			},
			"ErrorCode": 0,
			"ErrorMessage": ""
		}
	];

	createSuccess(bestHand){
		var success = this.cannedFailure;
		success.Payload.Match.UserMatchRounds[2] = {
			"RoundNum": 3,
			"Score": 9,
			"FinalScore": 18,
			"FreeRollsUsed": 0,
			"State": 3,
			"BestHand": bestHand,
			"BestPossibleHand": true,
			"FinalDiceRoll": null,
			"Rolls": this.hands[2].rolls
		}
		return success;
	}

	cannedFailure = {
		"Payload": {
			"Match": {
				"Id": 33,
				"Version": 1,
				"Winner": 0,
				"State": 3,
				"PlayerCount": 2,
				"RoundCount": 3,
				"CreatedTimestamp": 1552001440,
				"UpdatedTimestamp": 1552001440,
				"UserMatchState": 2,
				"UserCurrentRound": 2,
				"UserFreeRolls": 2,
				"UserFreeRollsUsed": 0,
				"UserTotalScore": 0,
				"OpponentUserId": 2,
				"OpponentUsername": "Practice Player",
				"OpponentTotalScore": 0,
				"Wager": {
					"Amount": {
						"Category": "currency",
						"Type": "chip",
						"Quantity": 0 //look for integration.tutorialWager
					},
					"State": "completed",
					"Resolution": {
						Amount: {
							Quantity: 0 //look for integration.tutorialPayout
						}
					}
				},
				"Resolution": null,
				"Refund": null,
				"Rounds": this.rounds.slice(0, 3),
				"UserMatchRounds": [{
					"RoundNum": 1,
					"Score": 2,
					"FinalScore": 4,
					"FreeRollsUsed": 0,
					"State": 3,
					"BestHand": [1, 5, 6, 2],
					"BestPossibleHand": false,
					"FinalDiceRoll": null,
					"Rolls": this.hands[0].rolls
				}, {
					"RoundNum": 2,
					"Score": 5,
					"FinalScore": 10,
					"FreeRollsUsed": 0,
					"State": 2,
					"BestHand": [1, 5, 3, 2, 0],
					"BestPossibleHand": false,
					"FinalDiceRoll": null,
					"Rolls": this.hands[1].rolls
				}, {
					"RoundNum": 3,
					"Score": 0,
					"FinalScore": 0,
					"FreeRollsUsed": 0,
					"State": 2,
					"BestHand": [],
					"BestPossibleHand": false,
					"FinalDiceRoll": null,
					"Rolls": []
				}],
				"OpponentMatchRounds": this.opponentMatchRounds.slice(0,3)
			},
		},
		"ErrorCode": 0,
		"ErrorMessage": ""
	}

	Response(response) {
		return Promise.resolve(response);
	}

	Error(message) {
		return Promise.reject({
			error: message
		});
	}

}
